import React from 'react';
import SEO from '../common/SEO';
import ColorSwitcher from '../elements/switcher/ColorSwitcher';
import FooterOne from '../common/footer/FooterOne';
import HeaderOne from '../common/header/HeaderOne';
import BreadCrumbOne from '../elements/breadcrumb/BreadCrumbOne';
import FormTwo from '../component/contact/FormTwo';
import SectionTitle from '../elements/section-title/SectionTitle';
import ContactLocation from '../component/contact/ContactLocation';



const Contact = () => {
    return (
        <>
            <SEO title="Blog Grid" />
            <ColorSwitcher />
            <main className="main-wrapper">
                <HeaderOne />
                <BreadCrumbOne 
                title="Contacto"
                page="Contact"
                />

            <div className="section section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-5 col-lg-6">
                            <div className="contact-form-box shadow-box mb--30">
                                <h3 className="title"> ¿Quieres potenciar tu proyecto?</h3>
                                                      
        <form name="contact" method="POST" data-netlify="true" className="axil-contact-form">
    
    <div className="form-group">
        <input type="text" className="form-control" name="nombre" placeholder="Nombre" required />
    </div>
    <div className="form-group">
        <input type="email" className="form-control" name="email" placeholder="Email" required />
    </div>
    <div className="form-group">
        <input type="tel" className="form-control" name="telefono" placeholder="Teléfono/ WhatsApp" required />
    </div>
    <div className="form-group">
        <input type="text" className="form-control" name="empresa" placeholder="Empresa" required />
    </div>
    <div className="form-group">
        <input type="text" className="form-control" name="web" placeholder="Sitio Web" />
    </div>
    <div className="form-group mb--40">
        <input type="text" className="form-control" name="mensaje" placeholder="Mensaje" />
    </div>
    <div className="form-group">
<select name="situacion">
<option value="null" selected >Cual es tu situación actual:</option>
<option value="opcion1">Tengo un e-Commerce en marcha, pero me gustaria potenciarlo.</option>
<option value="opcion2">Cuento con un proyecto, pero necesito acompañamiento.</option>
<option value="opcion3">Necesito servicio de Community Management.</option>
<option value="opcion4">No hago nada de Ads y quiero empezar.</option>
<option value="otro">Otro</option>
</select>
    </div>
    <div className="form-group">
      <input type="hidden" name="form-name" value="contact" />
        <button type="submit" className="axil-btn btn-fill-primary btn-fluid btn-primary" name="submit-btn">Enviar</button>
    </div>

</form>
                            </div>
                        </div>
                        <div className="col-xl-5 col-lg-6 offset-xl-1">
                            <div className="contact-info mb--100 mb_md--30 mt_md--0 mt--150">
                                <h4 className="title">Phone</h4>
                                <p>Our customer care is open from Mon-Fri, 10:00 am to 6:00 pm</p>
                                <h4 className="phone-number"><a href="tel:1234567890">(123) 456 7890</a></h4>
                            </div>
                            <div className="contact-info mb--30">
                                <h4 className="title">Email</h4>
                                <p>Our support team will get back to in 48-h during standard business hours.</p>
                                <h4 className="phone-number"><a href="mailto:info@example.com">info@example.com</a></h4>
                            </div>
                        </div>
                    </div>
                </div>
                <ul className="list-unstyled shape-group-12">
                    <li className="shape shape-1"><img src={process.env.PUBLIC_URL + "/images/others/bubble-2.png"} alt="Bubble" /></li>
                    <li className="shape shape-2"><img src={process.env.PUBLIC_URL + "/images/others/bubble-1.png"} alt="Bubble" /></li>
                    <li className="shape shape-3"><img src={process.env.PUBLIC_URL + "/images/others/circle-3.png"} alt="Circle" /></li>
                </ul>
            </div>

            <div className="section section-padding bg-color-dark overflow-hidden">
                <div className="container">
                    <SectionTitle 
                        subtitle="Find Us"
                        title="Our office"
                        description=""
                        textAlignment="heading-light-left"
                        textColor=""
                    />
                    <div className="row">
                        <ContactLocation />
                    </div>
                </div>
                <ul className="shape-group-11 list-unstyled">
                    <li className="shape shape-1"><img src={process.env.PUBLIC_URL + "/images/others/line-6.png"} alt="line" /></li>
                    <li className="shape shape-2"><img src={process.env.PUBLIC_URL + "/images/others/circle-3.png"} alt="line" /></li>
                </ul>
            </div>

            <FooterOne parentClass="pt--150 pt_lg--100 pt_md--80 pt_sm--60" />
            </main>
        </>
    )
}

export default Contact;